export enum GraphicActionTypes {
	SET_MAP_MODE = 'SET_MAP_MODE',
	SET_GRAPHIC_ACTION_TYPE = 'SET_GRAPHIC_ACTION_TYPE',
	SET_SPACE_OBJECT_DATA = 'SET_SPACE_OBJECT_DATA',
	SET_MAP_DIRECTORY_DATA = 'SET_MAP_DIRECTORY_DATA',
	MAP_HAS_CHANGED = 'MAP_HAS_CHANGED',
	SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE',
	SET_ERROR_MESSAGES = 'SET_ERROR_MESSAGES',
	SET_DROP_DATA_NODES = 'SET_DROP_DATA_NODES',
	DISABLE_MENU_OPTS = 'DISABLE_MENU_OPTS',
	SET_ALARM_PERMISSIONS = 'SET_ALARM_PERMISSIONS',
	SET_CURRENT_REDLINE_CONFIG_VALUES = 'SET_CURRENT_REDLINE_CONFIG_VALUES',
	SWITCH_FLOATING_WINDOW_VISIBILITY = 'SWITCH_FLOATING_WINDOW_VISIBILITY',
	SAVE_GRAPHIC_PREFERENCES = 'SAVE_GRAPHIC_PREFERENCES',
	SAVE_GRAPHIC_PREFERENCES_SUCCESS = 'SAVE_GRAPHIC_PREFERENCES_SUCCESS',
	SET_LAST_OBJECT_LIBRARY_COORDINATES = 'SET_LAST_OBJECT_LIBRARY_COORDINATES',
	SET_LAST_PLOTTED_DEVICES_COORDINATES = 'SET_LAST_PLOTTED_DEVICES_COORDINATES',
	SET_LAST_ALARM_QUEUE_COORDINATES = 'SET_LAST_ALARM_QUEUE_COORDINATES',
}
